export const TagIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Tag",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path d="M12 2H22V12L12 22L2 12L12 2Z" />
      <path d="M19 7C19 8.1046 18.1046 9 17 9C15.8954 9 15 8.1046 15 7C15 5.8954 15.8954 5 17 5C18.1046 5 19 5.8954 19 7Z" />
    </svg>
  );
};
